import AlertViewPage from "./AlertViewContainer";

export default AlertViewPage;
